import { render, staticRenderFns } from "./EventsSteward.vue?vue&type=template&id=e4ddd864&scoped=true"
import script from "./EventsSteward.vue?vue&type=script&lang=js"
export * from "./EventsSteward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ddd864",
  null
  
)

export default component.exports